import React from 'react';
import logo from '../images/logo.svg';
function Footer(){
    return (
        <footer>
            <div className="mt-16 bg-footer-bg bodertlr py-8 px-4 md:px-16 w-full">
        <div className="  md: justify-start">
            <div className="grid grid-cols-12 gap-10 md:gap-14 ">
                <div className="col-span-12 sm:col-span-12 md:col-span-3 sm:justify-self-center lg:justify-self-start lg:col-span-3 xxl:col-span-3 py-4">
                    <img src={logo} className="w-24 " alt="logo"/>
                </div>
                <div className="col-span-12 sm:col-span-12 md:col-span-3 sm:text-center lg:col-span-3 xxl:col-span-3 lg:text-left">
                    <h1 className="text-white font-medium py-3">Product</h1>
                    <a href="#" className="">
                        <p className="text-footer-text text-sm  pb-1 hover:text-gray-100  ">Overview</p>
                    </a>
                    <a href="#">
                        <p className="text-footer-text text-sm  pb-1 hover:text-gray-100 ">Pricing</p>
                    </a>
                    <a href="#">
                        <p className="text-footer-text text-sm  pb-1 hover:text-gray-100 ">Marketplace</p>
                    </a>
                    <a href="#">
                        <p className="text-footer-text text-sm  pb-1 hover:text-gray-100 ">Features</p>
                    </a>
                    <a href="#">
                        <p className="text-footer-text text-sm  pb-1 hover:text-gray-100 ">Integrations</p>
                    </a>
                </div>
                <div className="col-span-12 sm:col-span-12 md:col-span-3 sm:text-center lg:col-span-3 xxl:col-span-3 ">
                    <h1 className="text-white font-medium py-3">Company</h1>
                    <a href="#" className="">
                        <p className="text-footer-text text-sm  pb-1 hover:text-gray-100 ">About</p>
                    </a>
                    <a href="#">
                        <p className="text-footer-text text-sm  pb-1 hover:text-gray-100 ">Team</p>
                    </a>
                    <a href="#">
                        <p className="text-footer-text text-sm  pb-1 hover:text-gray-100 ">Blog</p>
                    </a>
                    <a href="#">
                        <p className="text-footer-text text-sm  pb-1 hover:text-gray-100 ">Careers</p>
                    </a>
                </div>
                <div className="col-span-12 sm:col-span-12 md:col-span-3 sm:text-center lg:col-span-3 xxl:col-span-3 ">
                    <h1 className="text-white font-medium py-3">Connect</h1>
                    <a href="#" className="">
                        <p className="text-footer-text text-sm  pb-1 hover:text-gray-100 ">Contact</p>
                    </a>
                    <a href="#">
                        <p className="text-footer-text text-sm  pb-1 hover:text-gray-100 ">Newsletter</p>
                    </a>
                    <a href="#">
                        <p className="text-footer-text text-sm  pb-1 hover:text-gray-100 ">LinkedIn</p>
                    </a>
                </div>
            </div>
        </div>
    </div>
    <div className="flex justify-end mt-4 sm:text-center">
       <p>Challenge by <a href="https://www.frontendmentor.io?ref=challenge  className=' text-dark-400 '" target="_blank">Frontend Mentor </a> 
    Coded by <a href="#" className='text-radical-red-400'>Shbhangini Sharma</a>.</p>
        </div>
        </footer>
    );
}
export default Footer;